export const activity = {
screenTitle: "Aktivität",
badgeContractor: "Auftragnehmer-Arbeitsbereich",
segmentInbox: "Benachrichtigungen",
segmentFeed: "Aktivität im Arbeitsbereich",
notifications: "Benachrichtigungen",
notificationFallback: "Benachrichtigung",
recentUpdates: "Neueste Updates",
fullFeed: "Gesamter Feed",
pendingApproval: "Wartet auf Ihre Antwort",
reviewRequired: "Prüfung erforderlich",
inspectionReportMeta: "Inspektionsbericht",
viewAsset: "Anlage anzeigen",
approvedForRepair: "Für Reparatur freigegeben",
repairsApproved_one: "{{count}} Reparatur freigegeben",
repairsApproved_other: "{{count}} Reparaturen freigegeben",
createJobs: "Aufträge erstellen",
awaitingRecipient: "Warten auf Empfänger",
firstShared: "Zuerst geteilt {{date}}",
resent: "Erneut gesendet {{date}}",
waitingForReview: "Warten auf Prüfung",
resendDeadline: "Erneut senden & Frist anpassen",
jobInvitations: "Auftragseinladungen",
jobFallbackTitle: "Auftrag #{{id}}",
acceptOrDecline: "Annehmen oder ablehnen",
accept: "Annehmen",
decline: "Ablehnen",
reportsSharedWithYou: "Mit Ihnen geteilte Berichte",
inspectionReportCard: "Inspektionsbericht",
emptyInboxTitle: "Nichts wartet auf Sie",
emptyInboxSub: "Freigaben, Einladungen und Antworten, die auf Sie warten, erscheinen hier.",
feedTitle: "Aktivitäts-Feed",
emptyFeedTitle: "Noch keine Aktivität",
emptyFeedSub: "Auftragszuweisungen, Statusänderungen und Freigaben erscheinen hier.",
events: {
  inspectionSentBack: "Inspektion zurückgeschickt",
jobAssigned: "Auftrag zugewiesen",
jobAssignedTo: "Auftrag an {{name}} zugewiesen",
jobAccepted: "Auftrag angenommen",
jobRejected: "Auftrag abgelehnt",
jobRejectedBy: "Auftrag von {{name}} abgelehnt",
jobStarted: "Auftrag gestartet",
jobScheduled: "Auftrag geplant",
jobReportShared: "Auftragsbericht geteilt",
teamMemberJoined: "Dem Team beigetreten",
jobPaused: "Auftrag pausiert",
jobResumed: "Auftrag fortgesetzt",
completionSubmitted: "Abschluss eingereicht",
jobVerified: "Auftrag verifiziert",
reworkRequested: "Nacharbeit angefordert",
reworkRequestedBy: "Nacharbeit von {{name}} angefordert",
evidenceRequested: "Weitere Nachweise angefordert",
evidenceRequestedBy: "Weitere Nachweise von {{name}} angefordert",
jobStatusChanged: "Auftrag {{status}}",
jobUpdatedFallback: "aktualisiert",
contractorInvited: "Auftragnehmer eingeladen",
contractorAccepted: "Auftragnehmer hat angenommen",
contractorDeclined: "Auftragnehmer hat abgelehnt",
quoteRequestSent: "Angebotsanfrage gesendet",
quoteSubmitted: "Angebot eingereicht",
quoteAccepted: "Angebot angenommen",
quoteRejected: "Angebot abgelehnt",
quoteDeclined: "Angebotsanfrage abgelehnt",
contractorAwarded: "Auftragnehmer beauftragt",
inspectionShared: "Inspektion geteilt",
inspectionCompleted: "Inspektion abgeschlossen",
inspectionApproved: "Inspektion freigegeben",
requestCreated: "Anfrage gestellt",
requestApproved: "Anfrage freigegeben",
requestDeclined: "Anfrage abgelehnt",
requestConverted: "Anfrage in Arbeit umgewandelt",
requestClosed: "Anfrage geschlossen",
assetDecommissioned: "Anlage außer Betrieb genommen",
assetRetired: "Anlage ausgemustert",
connectedAlert: "Gerätealarm",
assetCreated: "Anlage hinzugefügt",
assetUpdated: "Anlage aktualisiert",
assetDeleted: "Anlage gelöscht",
assetInService: "Anlage wieder in Betrieb",
contactAdded: "Kontakt hinzugefügt",
contactSharedTeam: "Kontakt mit Team geteilt",
contactPromoted: "Kontakt zum Konto hochgestuft",
contactInvited: "Kontakt eingeladen",
contactLinked: "Kontakt verknüpft",
assetRelAdded: "Anlagenbeziehung hinzugefügt",
assetRelUpdated: "Anlagenbeziehung aktualisiert",
assetRelRemoved: "Anlagenbeziehung entfernt",
duplicateMarked: "Duplikat-Anlage markiert",
canonicalSet: "Haupt-Anlage festgelegt",
duplicatesMerged: "Duplikat-Anlagen zusammengeführt",
approvalWithAsset: "Inspektion für {{asset}} von {{recipient}} genehmigt",
approvalByRecipient: "Inspektionsbericht von {{recipient}} genehmigt",
approvalGeneric: "Inspektionsbericht genehmigt",
rejectionWithAsset: "Inspektion für {{asset}} von {{recipient}} abgelehnt",
rejectionByRecipient: "Inspektionsbericht von {{recipient}} abgelehnt",
rejectionGeneric: "Inspektionsbericht abgelehnt",
},
jobStatus: {
draft: "Entwurf",
open: "Offen",
accepted: "Angenommen",
scheduled: "Geplant",
inProgress: "In Bearbeitung",
paused: "Pausiert",
completed: "Abgeschlossen",
verified: "Verifiziert",
rejected: "Abgelehnt",
cancelled: "Storniert",
},
insights: {
  kpiName: {
    portfolio_condition: "Gesamtzustand",
    assets_good_condition: "Anlagen in gutem Zustand",
    inspection_pass_rate: "Bestandene Inspektionen",
    first_time_fix: "Beim ersten Mal behoben",
    backlog_weeks: "Offene Arbeit (Wochen)",
    mttr: "Durchschnittliche Reparaturzeit",
    maintenance_approval_turnaround: "Zeit bis zur Freigabe",
    maintenance_reassignment_rate: "Arbeit neu zugewiesen",
    maintenance_reschedule_rate: "Wartung verschoben",
    maintenance_missed_rate: "Wartung versäumt",
    maintenance_skip_rate: "Wartung übersprungen",
    on_time_completion: "Pünktlich erledigt",
    reactive_vs_planned: "Ungeplante Arbeit",
    pm_schedule_compliance: "Geplante Wartung pünktlich",
    cert_currency: "Gültige Zertifikate",
    statutory_compliance: "Gesetzliche Compliance",
  },
  kpiTarget: "Ziel {{target}}",
  headlineKpi: {
    health: "Zustand",
    riskLevel: "Risikostufe",
    atRisk: "Gefährdete Anlagen",
    outOfService: "Außer Betrieb",
    onTime: "Pünktlich",
    compliance: "Konformität",
    ofTotal: "von {{total}}",
    noCompletedJobsWithDueDates: "keine abgeschlossenen Aufträge mit Fälligkeitsdatum",
    nothingToProveYet: "noch nichts nachzuweisen",
    registerNotLoaded: "Compliance-Register nicht geladen",
  },
  kpiDetail: {
    requirementsCompliant_one: "{{compliant}} von {{count}} Anforderung erfüllt",
    requirementsCompliant_other: "{{compliant}} von {{count}} Anforderungen erfüllt",
    certsCurrent: "{{valid}} von {{total}} gültig",
    onSchedule: "{{completed}} von {{total}} planmäßig",
    jobsReactive_one: "{{reactive}} von {{count}} Auftrag ungeplant",
    jobsReactive_other: "{{reactive}} von {{count}} Aufträgen ungeplant",
    onTime: "{{onTime}} von {{total}} pünktlich",
    plannedOccurrences_one: "{{done}} von {{count}} geplanten Termin",
    plannedOccurrences_other: "{{done}} von {{count}} geplanten Terminen",
    pastDueNoDecision: "{{missed}} von {{total}} überfällig ohne Entscheidung",
    movedWithDelay_one: "{{moved}} von {{total}}, im Schnitt {{count}} Tag Verzug",
    movedWithDelay_other: "{{moved}} von {{total}}, im Schnitt {{count}} Tage Verzug",
    moved: "{{moved}} von {{total}} verschoben",
    decidedWaiting: "{{decided}} entschieden, {{pending}} offen",
    decided: "{{decided}} entschieden",
    completedJobs_one: "{{count}} abgeschlossener Auftrag",
    completedJobs_other: "{{count}} abgeschlossene Aufträge",
    noOpenJobs: "Keine offenen Aufträge",
    noRecentCompletions: "Keine kürzlich abgeschlossenen Aufträge, um das Tempo hochzurechnen",
    openPerWeek: "{{open}} offen · {{rate}}/Wo.",
    reopenedOf: "{{reopened}} von {{total}} wiedereröffnet",
    itemsOf_one: "{{pass}} von {{count}} Prüfpunkt",
    itemsOf_other: "{{pass}} von {{count}} Prüfpunkten",
    postureCounts: "{{clear}} gut · {{watch}} beobachten · {{action}} Handlungsbedarf",
    atRiskOf: "{{atRisk}} von {{total}} gefährdet",
  },
  kpiUnit: {
    days: "{{value}} T.",
    weeks: "{{value}} Wo.",
  },
  kpiTargetValue: {
    reactive: "≤ 20 % ungeplant",
    oneDay: "≤ 1 Tag",
    trendDown: "fallender Trend",
    trendUp: "steigender Trend",
    underFourWeeks: "< 4 Wochen",
    rework: "Nacharbeit ≤ 5 %",
  },
  forecast: {
    certificatesLapse_one: "{{count}} Zertifikat läuft innerhalb von {{days}} Tagen ab",
    certificatesLapse_other: "{{count}} Zertifikate laufen innerhalb von {{days}} Tagen ab",
    moreSuffix_one: "+{{count}} weiteres",
    moreSuffix_other: "+{{count}} weitere",
    backlogStalled_one: "Rückstand von {{count}} Auftrag wird nicht abgearbeitet",
    backlogStalled_other: "Rückstand von {{count}} Aufträgen wird nicht abgearbeitet",
    backlogStalledDetail: "In den letzten 4 Wochen wurde kein Auftrag abgeschlossen – ohne Maßnahmen wächst der Rückstand weiter.",
    backlogGrowing: "Rückstand wächst voraussichtlich in 4 Wochen auf ~{{projected}}",
    backlogGrowingDetail: "Eingang {{inflow}}/Wo. gegenüber Erledigung {{velocity}}/Wo. – die Kapazität liegt unter dem Bedarf.",
    backlogBurndown: "Rückstand ist beim aktuellen Tempo in ~{{weeks}} Wochen abgearbeitet",
    backlogBurndownDetail: "{{open}} offen · Erledigung {{velocity}}/Wo. gegenüber Eingang {{inflow}}/Wo.",
    declineTitle: "{{name}} rutscht voraussichtlich bald auf „Handlungsbedarf“",
    declineDetailDocument: "Derzeit „Beobachten“ ({{score}}/100); {{regulation}} läuft innerhalb von 30 Tagen ab.",
    declineDetailSchedule: "Derzeit „Beobachten“ ({{score}}/100) mit einer fälligen oder überfälligen geplanten Inspektion.",
  },
  sections: {
    a11y: "Analysen-Bereiche",
    workflows: "Arbeitsabläufe",
    overview: "Überblick",
  },
chart: {
emptyReason: {
noRecords: "Keine Datensätze verfügbar",
noQualifyingRecords: "Keine qualifizierenden Datensätze",
filteredEmpty: "Keine Treffer für diese Filter",
insufficientSample: "Noch nicht genügend Nachweise",
notApplicable: "Nicht anwendbar",
loadFailed: "Diagrammdaten konnten nicht geladen werden",
stale: "Daten müssen aktualisiert werden",
},
defaultAccessibilityLabel: "Diagramm",
},
shell: {
hideDetails: "Einblickdetails ausblenden",
showDetailsSuffix: "Einblickdetails anzeigen.",
expandHint: "Doppeltippen, um das vollständige Einblickfenster zu erweitern",
},
conditionPortfolio: {
stableCount_one: "{{count}} stabil.",
stableCount_other: "{{count}} stabil.",
band: {
critical: "Kritisch",
action_recommended: "Maßnahme empfohlen",
deteriorating: "Verschlechternd",
watch: "Beobachten",
stable: "Stabil",
},
bandInfo: {
critical: "Anlagen, die laut Nachweis jetzt Aufmerksamkeit brauchen: nicht bestandene Sicherheitspunkte, überfällige dringende Arbeit oder ein schneller Verfall.",
action_recommended: "Anlagen, die sich verschlechtern und für die eine geplante Maßnahme empfohlen wird, bevor sie kritisch werden.",
deteriorating: "Anlagen, deren Prüfungen, Reparaturen oder Wartungsverlauf einen stetigen Verfall zeigen.",
watch: "Anlagen mit einem frühen Warnzeichen, das beobachtet werden sollte, noch kein Verfall.",
},
noDominantDriver: "Keine einzelne Ursache sticht heraus.",
recurringFault_one: "{{count}} Anlage mit einem wiederkehrenden Fehler",
recurringFault_other: "{{count}} Anlagen mit einem wiederkehrenden Fehler",
repeatRepairs: "{{count}} mit wiederholten Reparaturen",
noExceptions: "Keine wiederkehrenden Fehler oder Wiederholungsreparaturen im gesamten Portfolio.",
noteSuffix: "Zählersignale werden auf jeder Anlage angezeigt, nicht hier.",
moreOnList: "+{{count}} mehr auf der Anlagenliste.",
wholeCountsNote: "Die Zahlen umfassen alle Anlagen, Stand {{date}}. Die aufgeführten Anlagen sind Beispiele aus den geladenen.",
},
panel: {
basedOn: "Basierend auf: {{source}}",
severityHighPriority: "Hohe Priorität",
severityAttention: "Aufmerksamkeit",
severityOnTrack: "Auf Kurs",
severityFyi: "Zu Ihrer Information",
severityNote: "Notiz",
moreItems: "+{{count}} weitere hier – filtern oder suchen, um einzugrenzen.",
signalsTitle: "Signale",
recommendedActionTitle: "Empfohlene Aktion",
},
kpiInfo: {
aboutLabel: "Über {{label}}",
hint: "Öffnet eine Erläuterung dieser Metrik und ihrer Verwendung",
},
metricInfoSheet: {
dismissOverlay: "Schließen",
close: "Schließen",
whatItMeasures: "WAS ES MISST",
howToUseIt: "WIE MAN ES VERWENDET",
basedOn: "BASIEREND AUF",
asOf: "Stand · {{value}}",
target: "Ziel · {{value}}",
},
priorityCard: {
feedbackHelpful: "Hilfreich",
feedbackNotUseful: "Nicht nützlich",
feedbackSnooze: "Zurückstellen",
feedbackDismiss: "Schließen",
recommended: "Empfohlen: {{action}}.",
effort: "Aufwand: {{value}}",
expectedBenefit: "Erwarteter Nutzen: {{value}}",
dataGaps: "Datenlücken",
butAlso: "Aber auch",
feedbackTrigger: "Insight-Feedback",
feedbackSheetTitle: "War das nützlich?",
},
journeys: {
tabExecutive: "Geschäftsführer",
tabRequest: "Anfrage",
tabInspection: "Inspektion",
tabJob: "Auftrag",
tabAsset: "Anlage",
tabContractor: "Auftragnehmer",
tabCompliance: "Konformität",
tablistLabel: "Journey-Dashboards",
executiveAssistantTitle: "Assistent der Geschäftsleitung",
pageTitle: "Journey-Analyse",
journeyCount_one: "{{count}} Journey",
journeyCount_other: "{{count}} Journeys",
requestFunnel: "Anfragen-Trichter",
journeyFunnel: "Journey-Trichter",
stageFlow: "Phasenablauf",
noJourneyFlow: "Noch kein Journey-Flow.",
durationDistribution: "Verteilung der Journey-Dauer",
noCompletedJourneys: "Noch keine abgeschlossenen Journeys.",
bottlenecksMedianGap: "Engpässe (mittlere Phasenlücke)",
bottleneckEmpty: "Noch nichts gemessen. Für einen Engpass ist mindestens eine Journey erforderlich, die zwei aufeinanderfolgende Schritte durchlaufen hat (z. B. Anfrage → Genehmigung).",
workFunnel: "Arbeitstrichter",
bottleneckRanking: "Engpass-Rangliste",
recentJourneyActivity: "Aktuelle Journey-Aktivität",
noRecentEvents: "Keine aktuellen Ereignisse.",
slaComplianceByStage: "SLA-Konformität nach Stufen",
slaEmpty: "Noch nichts gemessen. Dies wird ausgefüllt, sobald eine Anfrage genehmigt wurde, eine Inspektion zu einem Arbeitsauftrag führt oder ein Arbeitsauftrag begonnen oder abgeschlossen wird – die Lücken zwischen diesen Schritten sind die Maßstäbe für die SLA-Konformität.",
bottlenecks: "Engpässe",
whatNeedsAttention: "Was Aufmerksamkeit erfordert",
},
screen: {
  aiSummaryButton: "KI-Zusammenfassung schreiben",
  emptyStartInspection: "Inspektion starten",
  emptyAddAsset: "Anlage hinzufügen",
scopeAllMultiTeam: "Die Arbeit aller – am besten für den Vergleich von Teams nebeneinander.",
scopeAllSingleTeam: "Die gesamte Arbeit in Ihrem Konto.",
scopePersonalMultiTeam: "Nur Ihre Arbeit. Wechseln Sie zu „Alle“, um das gesamte Team anzuzeigen.",
scopePersonalSingleTeam: "Nur Ihre Arbeit.",
scopeTeamMultiTeam: "Nur {{team}} ist enthalten. Wechseln Sie den Bereich auf „Alle“, um Teams nebeneinander zu vergleichen.",
scopeTeamSingleTeam: "Nur {{team}} ist enthalten.",
greetingLate: "Noch spät bei der Arbeit",
greetingMorning: "Guten Morgen",
greetingAfternoon: "Guten Tag",
greetingEvening: "Guten Abend",
greetingNoPriorities: "Keine Prioritäten heute. Trends unten, während sich Daten aufbauen.",
greetingDanger_one: "{{count}} Problem erfordert heute Aufmerksamkeit – der oberste Eintrag hat ein hohes Risiko.",
greetingDanger_other: "{{count}} Probleme erfordern heute Aufmerksamkeit – der oberste Eintrag hat ein hohes Risiko.",
greetingTechnician_one: "Sie haben {{count}} anstehende Aufgabe. Beginnen Sie mit der obersten Karte.",
greetingTechnician_other: "Sie haben {{count}} anstehende Aufgaben. Beginnen Sie mit der obersten Karte.",
greetingExecutive_one: "{{count}} Signal ist einen Blick wert – sortiert nach finanziellem Risiko.",
greetingExecutive_other: "{{count}} Signale sind einen Blick wert – sortiert nach finanziellem Risiko.",
greetingTeam_one: "{{count}} Priorität für das Team heute.",
greetingTeam_other: "{{count}} Prioritäten für das Team heute.",
loadingTitle: "Analysen werden geladen",
emptyGetsUsefulTitle: "Analysen werden mit der Nutzung aussagekräftig",
emptyGetsUsefulDescription: "Fügen Sie eine Anlage hinzu oder starten Sie eine Inspektion. Die Analysen zeigen dann, was Aufmerksamkeit braucht und was in Verzug gerät.",
partialDataCaption: "Diese Diagramme verwenden geladene Datensätze. Die Portfoliosummen sind möglicherweise unvollständig.",
partialDataCaptionConditionWhole: "Zustand, Risikostufe, gefährdete und außer Betrieb befindliche Anlagen umfassen alle Anlagen. Die übrigen Kennzahlen und Diagramme verwenden geladene Datensätze und sind möglicherweise unvollständig.",
partialDataCaptionConditionBandsWhole: "Zustand, Risikostufe, gefährdete und außer Betrieb befindliche Anlagen, die Zustandsbänder und Anlagen in gutem Zustand umfassen alle Anlagen. Die übrigen Kennzahlen und Diagramme verwenden geladene Datensätze und sind möglicherweise unvollständig.",
refreshErrorTitle: "Einige Analysedaten konnten nicht aktualisiert werden",
refreshErrorDescription: "Die folgenden Diagramme verwenden zwischengespeicherte Datensätze und sind möglicherweise unvollständig. Versuchen Sie es erneut, wenn Ihre Verbindung verfügbar ist.",
roleTechnician: "Techniker",
roleManager: "Leitung",
roleExecutive: "Geschäftsführer",
switchToRoleView: "Zur {{role}}-Ansicht wechseln",
resetToAutoLabel: "Zurücksetzen auf die automatisch erkannte Ansicht",
resetToAutoText: "Auf automatisch zurücksetzen",
showingLabel: "wird angezeigt",
clearSiteFilter: "Standortfilter entfernen",
allSites: "Alle Standorte",
unassignedSite: "Nicht zugewiesen",
selectedSiteFallback: "Ausgewählter Standort",
standardsEyebrow: "Normen",
operationalKpisTitle: "Operative KPIs",
subtitleNeedAttention_one: "{{count}} braucht Aufmerksamkeit · {{onTrack}} im Ziel",
subtitleNeedAttention_other: "{{count}} brauchen Aufmerksamkeit · {{onTrack}} im Ziel",
subtitleAllOnTarget_one: "{{count}} KPI im Plan",
subtitleAllOnTarget_other: "Alle {{count}} KPIs im Plan",
asOfSuffix: "Stand {{time}}",
kpiAllClearAccessibilityLabel_one: "{{count}} KPI im Plan. Alle anzeigen.",
kpiAllClearAccessibilityLabel_other: "Alle {{count}} KPIs im Plan. Alle anzeigen.",
kpiAllClearText_one: "{{count}} KPI im Plan",
kpiAllClearText_other: "Alle {{count}} KPIs im Plan",
showAllLabel: "Alle anzeigen",
hideOnTargetKpis: "KPIs im Plan ausblenden",
showOnTargetKpis_one: "{{count}} KPI im Plan anzeigen",
showOnTargetKpis_other: "{{count}} KPIs im Plan anzeigen",
conditionEyebrow: "Zustand",
conditionTitle: "Welche Anlagen verfallen?",
conditionSubtitle: "Abgeleitet aus der Inspektions-, Reparatur- und Wartungshistorie. Tippen Sie auf eine Anlage, um die vollständigen Nachweise anzuzeigen.",
maintenanceEyebrow: "Wartung",
maintenanceTitle: "Wo gerät die Wartung in Verzug?",
maintenanceSubtitle: "Übersprungene Arbeit wurde bewusst ausgelassen, versäumte nicht. Beide werden getrennt gezählt.",
sitesEyebrow: "Standorte",
sitesTitle: "Welcher Standort braucht Aufmerksamkeit?",
sitesSubtitle: "Zustand nach Standort, schlechtester zuerst. Tippen Sie auf einen Standort, um das gesamte Dashboard darauf zu konzentrieren.",
focusOnSiteLabel: "Fokus auf {{name}}. Gesundheit {{score}} von 100.",
healthDetail: "Gesundheit {{score}}/100 · {{atRisk}} von {{total}} gefährdet",
profileEyebrow: "Profilvollständigkeit",
profileTitle: "Anlagen mit fehlenden Profildetails",
profileSubtitle: "In diesen Anlagendatensätzen fehlen Felder, die von Checklisten, Risikoberechnungen und Empfehlungen verwendet werden.",
profileRowLabel: "{{needsData}} von {{total}} Anlagen weisen unvollständige Profile auf. Öffnen Sie die Liste.",
profileRowTitle: "{{needsData}} von {{total}} Anlagenprofilen sind unvollständig",
profileWeak_one: "{{count}} hat sehr wenig strukturierte Details. Öffnen Sie die Liste, um die Lücken zu schließen.",
profileWeak_other: "{{count}} haben sehr wenig strukturierte Details. Öffnen Sie die Liste, um die Lücken zu schließen.",
profileOpenList: "Öffnen Sie die Liste, um die fehlenden Felder zu überprüfen und auszufüllen.",
forecastEyebrow: "Prognose",
forecastTitle: "Was kommt",
forecastSubtitle: "Vorhergesagt anhand von Zertifikatsabläufen, Zeitplänen und Abschlusstempo – handeln Sie, bevor etwas in Verzug gerät.",
todayEyebrow: "Heute",
topPrioritiesTitle: "Höchste Prioritäten",
subtitleTechnician: "Ihre nächsten Arbeitsaufträge, sortiert nach Dringlichkeit.",
subtitleManager: "Die fünf wichtigsten Prioritäten in Ihrem Bereich, mit Begründung und einer empfohlenen Maßnahme.",
visibleOfTotal: "{{visible}} von {{total}}",
viewDetailsLabel: "Details anzeigen",
workloadLabel: "Arbeitslast",
reportingInsightLabel: "Einblicke in die Berichterstattung",
clearedTitle: "Alles erledigt.",
clearedBody: "Im Moment gibt es keine Prioritäten – wir werden neue aufdecken, sobald Daten eingehen.",
riskEyebrow: "Risiko",
riskTitle: "Wo konzentriert sich das Risiko?",
riskSubtitle: "Rangfolge der Risiken im gesamten Portfolio, aufgeschlüsselt nach Kritikalität und Fehlerart.",
rankedCount_one: "{{count}} eingestuft",
rankedCount_other: "{{count}} eingestuft",
topExposuresEyebrow: "Größte Zustandsrisiken",
topExposuresTitle: "Welche Anlagen sind am stärksten exponiert?",
nextAssetCaption: " Als Nächstes: {{name}} (Zustand {{score}}/100).",
riskHeatmapEyebrow: "Risiko-Heatmap",
riskHeatmapTitle: "Kritizität × Anlagentyp",
riskHeatmapCaption: "Dunklere Zellen = höhere durchschnittliche Risikobewertung.",
riskByCriticalityEyebrow: "Risiko nach Kritikalität",
riskByCriticalityTitle: "Wie wird das Risiko nach Kritikalitätsstufe verteilt?",
riskByCriticalityCaption_one: "{{count}} Anlage gefährdet · Risikobewertung von 50/100 oder höher. Bei Anlagen, die unter diesem Schwellenwert liegen, sind möglicherweise noch Arbeiten überfällig.",
riskByCriticalityCaption_other: "{{count}} gefährdete Anlagen · Risikobewertung von 50/100 oder höher. Bei Anlagen, die unter diesem Schwellenwert liegen, sind möglicherweise noch Arbeiten überfällig.",
topFailuresEyebrow: "Top-Fehlerkategorien",
topFailuresTitle: "Was schlägt am häufigsten fehl?",
topFailuresCaption_one: "{{label}} führt mit {{count}} markiertem Punkt – Ursache untersuchen.",
topFailuresCaption_other: "{{label}} führt mit {{count}} markierten Punkten – Ursache untersuchen.",
fewerAnalytics: "Weniger Analysen",
moreAnalytics: "Mehr Analysen",
flowEyebrow: "Fluss",
flowTitle: "Wie läuft die Arbeit ab?",
flowSubtitle: "Rückstandsform und Prüfqualität in den letzten 28 Tagen.",
backlogEyebrow: "Backlog-Zusammensetzung",
backlogTitle: "Schrumpft oder wächst der Rückstand?",
backlogCaption: "Heute: {{overdue}} überfällig · {{dueSoon}} bald fällig · {{upcoming}} demnächst.",
legendOverdue: "Überfällig",
legendDueIn7d: "Fällig in 7 Tagen",
legendUpcoming: "Demnächst",
passRateEyebrow: "Inspektionserfolgsquote",
passRateTitle: "Geht der Trend bei Inspektionen zu bestanden oder nicht bestanden?",
passRateCaption: "Derzeit {{current}}% (gegenüber {{prev}}% vor 28 Tagen – {{arrow}} {{delta}}pts).",
passRateEmpty: "Führen Sie weitere Inspektionen durch, um den Trend zu füllen.",
noScheduledTitle: "Noch keine geplanten Einträge.",
noScheduledDescription: "Sobald datierte Arbeitsaufträge und Inspektionen verfügbar sind, werden hier Arbeitsbelastungstrends angezeigt.",
teamsEyebrow: "Teams und Partner",
teamsTitle: "Wie schneiden Teams und Auftragnehmer ab?",
teamsSubtitle: "Rankings verwenden Ihren aktuellen Umfang ({{scope}}). Vergleichen Sie Teams, wenn der Umfang „Alle“ ist.",
compareTeamsTitle: "Vergleichen Sie Teams nebeneinander",
compareTeamsBody: "Sie sehen {{scope}}. Wechseln Sie zu „Alle“, um die Arbeitsbelastung und den Durchsatz aller Teams anzuzeigen.",
switchToAll: "Wechseln Sie zu „Alle“.",
switchScopeAllLabel: "Stellen Sie den Bereich auf „Alle“ um, um Teams zu vergleichen",
teamWorkloadEyebrow: "Arbeitsbelastung des Teams",
teamWorkloadTitle: "Welche Teams tragen die meisten offenen Arbeiten?",
teamThroughputEyebrow: "Teamdurchsatz",
teamThroughputTitle: "Wer hat in 28 Tagen die meisten Arbeiten abgeschlossen?",
cycleTimesShown: "Zykluszeiten werden angezeigt, wenn abgeschlossene Arbeitsaufträge Start- und Enddaten haben.",
completedCountsCaption: "Anzahl abgeschlossener Arbeiten der letzten 28 Tage in Ihrem aktuellen Bereich.",
openLabel_one: "{{count}} offen",
openLabel_other: "{{count}} offen",
overdueUnassigned: "{{overdue}} überfällig · {{unassigned}} nicht zugewiesen",
unassignedOnly_one: "{{count}} nicht zugewiesen",
unassignedOnly_other: "{{count}} nicht zugewiesen",
doneLabel_one: "{{count}} erledigt",
doneLabel_other: "{{count}} erledigt",
avgCycleDays: "{{days}}d durchschnittlicher Zyklus",
stillOpen_one: "{{count}} noch offen",
stillOpen_other: "{{count}} noch offen",
contractorPerformanceEyebrow: "Auftragnehmerleistung",
contractorPerformanceTitle: "Wie schneiden die Auftragnehmer im Vergleich ab?",
overdueOnly_one: "{{count}} überfällig",
overdueOnly_other: "{{count}} überfällig",
doneWindow_one: "{{count}} erledigt (28 T.)",
doneWindow_other: "{{count}} erledigt (28 T.)",
sentBack_one: "{{count}} zurückgeschickt",
sentBack_other: "{{count}} zurückgeschickt",
avgCycle: "{{days}}d durchschn",
toAnswer: "{{hours}}h zur Beantwortung",
declinedOnly_one: "{{count}} abgelehnt",
declinedOnly_other: "{{count}} abgelehnt",
techQualityEyebrow: "Technikerqualität",
techQualityTitle: "Welche Techniker brauchen Coaching?",
techQualityCaption_one: "Score kombiniert pünktliche Fertigstellung abzüglich Wiedereröffnungen (0–100). Median {{median}}/100 über {{count}} Techniker.",
techQualityCaption_other: "Score kombiniert pünktliche Fertigstellung abzüglich Wiedereröffnungen (0–100). Median {{median}}/100 über {{count}} Techniker.",
technicianFallback: "Techniker",
needsCoaching: "Benötigt Coaching",
starPerformer: "Star-Performer",
onTrack: "Auf Kurs",
slippageEyebrow: "Verzug",
slippageTitle: "Was gerät in Verzug?",
slippageSubtitle: "Inspektionsabdeckung, Konformitätsverstöße und Lücken in Ihrem Inspektionsrhythmus.",
coverageGapsEyebrow: "Abdeckungslücken",
coverageGapsTitle: "Welche Anlagen müssen jetzt überprüft werden?",
coverageGapsCaptionKnown: "Oberster Eintrag: {{label}} ({{days}} T. seit der letzten Inspektion). Die Einträge sind nach Tagen × betrieblicher Auswirkung sortiert.",
coverageGapsCaptionNever: "Oberster Eintrag: {{label}} (nie geprüft). Die Einträge sind nach Tagen × betrieblicher Auswirkung sortiert.",
neverLabel: "Nie",
complianceExpirationsEyebrow: "Konformitätsabläufe",
complianceExpirationsTitle: "Was verfällt in den nächsten 90 Tagen?",
complianceExpirationsCaption: "Bereits abgelaufen: {{expired}}, Ablauf innerhalb von 14 Tagen: {{expiringSoon}}.",
overdueDays: "{{days}}d überfällig",
daysLeft: "{{days}} T. verbleibend",
inspectionDensityEyebrow: "Inspektionsdichte",
inspectionDensityTitle: "Wo gibt es Lücken im Inspektionsrhythmus?",
inspectionDensityCaption_one: "{{count}} Inspektion in den letzten ~6 Monaten. Leere Abschnitte zeigen Abdeckungslücken.",
inspectionDensityCaption_other: "{{count}} Inspektionen in den letzten ~6 Monaten. Leere Abschnitte zeigen Abdeckungslücken.",
activityEyebrow: "Aktivität",
activityTitle: "Was ist gerade passiert?",
activitySubtitle: "Neueste Inspektionen und Arbeitsauftragsaktualisierungen für Ihren gesamten Bereich.",
whenToday: "heute",
whenYesterday: "gestern",
whenDaysAgo: "vor {{days}} T.",
severityFooterText: "Der Schweregrad wird als betriebliche Auswirkung (Niedrig → Kritisch) und nicht als Dollarwert angezeigt. AssetWRX verwaltet keine Gewinne und Verluste – Kostendaten gehören in Ihr ERP. Wenn Sie eines anschließen, können hier $-Zahlen hinzugefügt werden.",
askTitle: "Fragen Sie AssetWRX",
askPlaceholderExecutive: "z. B. Welche Standorte haben im letzten Quartal am meisten gekostet?",
askPlaceholderTechnician: "z.B. Welche Arbeitsaufträge habe ich heute?",
askPlaceholderManager: "z.B. Welche Anlagen sind zur Prüfung fällig?",
askButton: "Fragen",
pageSubtitle: "Sehen Sie, wo sich die Arbeit häuft, welche Anlagen gefährdet sind und wer überlastet ist.",
},
},
title: "Aktivität",
viewFeed: "Teamaktivität ansehen",
analyticsTitle: "Analysen",
recommendations: {
whyPrefix: "Warum:",
failureTitle: "{{asset}} — Gesundheit {{score}}/100",
impactRisk: "Risiko",
actionOpenAsset: "Anlage öffnen",
actionScheduleAction: "Maßnahme planen",
actionAssignTechnician: "Techniker zuweisen",
thinHistory: "Wenig Verlauf für diese Anlage — erfassen Sie eine Inspektion, um den Wert abzusichern.",
overdueTitle_one: "{{count}} überfälliger Auftrag in Ihrem Bereich",
overdueTitle_other: "{{count}} überfällige Aufträge in Ihrem Bereich",
overdueWhy: "Warum: Fälligkeitsdaten sind ohne Abschluss verstrichen — der Rückstand wächst.",
impactOldest: "Ältester",
oldestValue_one: "{{count}} T. überfällig",
oldestValue_other: "{{count}} T. überfällig",
actionTriageBacklog: "Rückstand sichten",
complianceTitle_one: "{{count}} Konformitätseintrag läuft innerhalb von 30 Tagen ab",
complianceTitle_other: "{{count}} Konformitätseinträge laufen innerhalb von 30 Tagen ab",
complianceWhy: "Warum: Zertifizierungen und Inspektionen verfallen, wenn niemand handelt.",
impactAtRisk: "Gefährdet",
assetsCount_one: "{{count}} Anlage",
assetsCount_other: "{{count}} Anlagen",
actionOpenCompliance: "Konformität öffnen",
trainingTitle_one: "{{count}} Techniker mit wiederholten Wiedereröffnungen",
trainingTitle_other: "{{count}} Techniker mit wiederholten Wiedereröffnungen",
trainingWhy: "Warum: Dieselbe Anlagenklasse wurde in 90 T. mehrfach wiedereröffnet — wahrscheinlich eine Schulungslücke.",
impactRecurringRework: "Wiederkehrende Nacharbeit",
reopensCount_one: "{{count}} Wiedereröffnung",
reopensCount_other: "{{count}} Wiedereröffnungen",
actionViewContacts: "Kontakte anzeigen",
inspectionDueTitle_one: "{{count}} Anlage braucht eine Inspektion",
inspectionDueTitle_other: "{{count}} Anlagen brauchen eine Inspektion",
inspectionDueWhy: "Warum: In den letzten 90 Tagen wurde keine Inspektion abgeschlossen.",
impactCoverageGap: "Abdeckungslücke",
actionScheduleInspections: "Inspektionen planen",
approvalsInspections_one: "{{count}} Inspektion wartet auf Freigabe",
approvalsInspections_other: "{{count}} Inspektionen warten auf Freigabe",
approvalsJobs_one: "{{count}} Auftrag wartet auf Verifizierung",
approvalsJobs_other: "{{count}} Aufträge warten auf Verifizierung",
approvalsTitle_one: "{{count}} Entscheidung wartet auf Sie",
approvalsTitle_other: "{{count}} Entscheidungen warten auf Sie",
approvalsWhyOne: "Warum: {{part}}. Die Arbeit bleibt offen, bis jemand sie abnimmt.",
approvalsWhyBoth: "Warum: {{first}} und {{second}}. Die Arbeit bleibt offen, bis jemand sie abnimmt.",
impactWaiting: "Wartend",
actionReviewApprove: "Prüfen und freigeben",
jobFallback: "Auftrag",
nextJobDue: "Warum: fällig am {{date}}.",
nextJobAssigned: "Warum: Ihnen zugewiesen.",
impactUrgency: "Dringlichkeit",
actionOpenJob: "Auftrag öffnen",
},
insightQuality: {
confidenceHigh: "Hohe Sicherheit",
confidenceMedium: "Mittlere Sicherheit",
confidenceLow: "Geringe Sicherheit",
notEnoughHistory: "{{label}} · zu wenig aktueller Verlauf",
basedOnOne: "{{label}} · basierend auf {{part}}",
basedOnBoth: "{{label}} · basierend auf {{first}} und {{second}}",
inspections_one: "{{count}} Inspektion",
inspections_other: "{{count}} Inspektionen",
jobs_one: "{{count}} Auftrag",
jobs_other: "{{count}} Aufträgen",
noInspectionsInScope: "Keine Inspektionen im Umfang",
limitedJobHistory: "Begrenzte Auftragshistorie",
noCompletedInspections: "Keine abgeschlossenen Inspektionen",
noInspectionInDays_one: "Keine Inspektion seit {{count}} Tag",
noInspectionInDays_other: "Keine Inspektion seit {{count}} Tagen",
noInspectionHistory: "Keine Inspektionshistorie",
assetMetadataIncomplete: "Anlagen-Stammdaten unvollständig",
noRecentTimestamps: "Keine Zeitstempel aktueller Aktivität",
dataGapNoInspection_one: "Datenlücke: keine Inspektion seit {{count}} Tag",
dataGapNoInspection_other: "Datenlücke: keine Inspektion seit {{count}} Tagen",
dataGapLastActivity_one: "Datenlücke: letzte Aktivität vor {{count}} Tag",
dataGapLastActivity_other: "Datenlücke: letzte Aktivität vor {{count}} Tagen",
limitedData: "Begrenzte Datenlage – nur als Richtwert verwenden",
},
activityTimeline: {
inspectionCompleted: "Inspektion abgeschlossen",
inspectionInProgress: "Inspektion läuft",
itemsFlagged_one: "{{count}} Punkt markiert",
itemsFlagged_other: "{{count}} Punkte markiert",
allPassing: "Alle Punkte bestanden",
jobUpdated: "Auftrag aktualisiert",
},
portfolioNarrative: {
flat: "Der Gesundheitswert des Portfolios liegt bei {{score}}/100 — Trends erscheinen, sobald mehr Daten vorliegen.",
improved_one: "Ihr Portfolio ist diesen Monat gesünder — der Betriebszustand stieg um {{count}} Punkt auf {{score}}/100{{driver}}.",
improved_other: "Ihr Portfolio ist diesen Monat gesünder — der Betriebszustand stieg um {{count}} Punkte auf {{score}}/100{{driver}}.",
improvedDriver_one: ", da {{count}} Anlage den gefährdeten Bereich verlassen hat",
improvedDriver_other: ", da {{count}} Anlagen den gefährdeten Bereich verlassen haben",
slipped_one: "Der Gesundheitswert des Portfolios sank diesen Monat um {{count}} Punkt auf {{score}}/100.",
slipped_other: "Der Gesundheitswert des Portfolios sank diesen Monat um {{count}} Punkte auf {{score}}/100.",
steady: "Der Gesundheitswert des Portfolios blieb diesen Monat stabil bei {{score}}/100.",
concern: " Im Blick behalten: {{concern}}.",
},
partnersCaptions: {
teamEmpty: "Weisen Sie Teams Aufträge zu, um Arbeitslast und Durchsatz zu vergleichen.",
teamSingle: "{{team}}: {{open}} offen, {{completed}} in {{days}} T. abgeschlossen.",
teamOverdue: "{{worst}} hat die meiste überfällige Arbeit ({{overdue}}); {{leader}} hat die größte offene Warteschlange ({{open}}).",
teamThroughput: "{{leader}} hat die größte offene Warteschlange; {{top}} hat in {{days}} T. am meisten abgeschlossen ({{completed}}).",
teamLeader_one: "{{leader}} hat die größte offene Warteschlange ({{count}} Auftrag).",
teamLeader_other: "{{leader}} hat die größte offene Warteschlange ({{count}} Aufträge).",
contractorEmpty: "Weisen Sie Aufträge zu, die Auftragnehmer ausführen, um hier deren Leistung zu sehen.",
contractorOverdue_one: "{{worst}} hat {{count}} überfälligen Auftrag; {{leader}} hat die höchste aktive Auslastung ({{open}} offen).",
contractorOverdue_other: "{{worst}} hat {{count}} überfällige Aufträge; {{leader}} hat die höchste aktive Auslastung ({{open}} offen).",
contractorRework_one: "Bei {{name}} wurde {{count}} Auftrag zurückgeschickt; {{leader}} führt bei offenen Zuweisungen ({{open}}).",
contractorRework_other: "Bei {{name}} wurden {{count}} Aufträge zurückgeschickt; {{leader}} führt bei offenen Zuweisungen ({{open}}).",
contractorCompleted_one: "{{name}} hat in {{days}} T. {{count}} Auftrag abgeschlossen; {{leader}} hat {{open}} offen.",
contractorCompleted_other: "{{name}} hat in {{days}} T. {{count}} Aufträge abgeschlossen; {{leader}} hat {{open}} offen.",
contractorLeader: "{{leader}} hat die höchste Auslastung unter den Auftragnehmern ({{open}} offen).",
},
siteRisk: {
whyTwoDrivers: "Betriebszustand {{score}}/100 — Hauptrisiken: {{first}} und {{second}}.",
whyOneDriver: "Betriebszustand {{score}}/100 — Hauptrisiko: {{driver}}.",
whyExposure: "Betriebszustand {{score}}/100 — Betriebsrisiko {{risk}}/100.",
subLabelExposure: "Betriebsrisiko {{risk}}/100",
},
rootCause: {
assetCount_one: "{{count}} Anlage",
assetCount_other: "{{count}} Anlagen",
dayCount_one: "{{count}} Tag",
dayCount_other: "{{count}} Tagen",
jobCount_one: "{{count}} Auftrag",
jobCount_other: "{{count}} Aufträge",
categoryJobs_one: "{{count}} Auftrag der Kategorie {{category}}",
categoryJobs_other: "{{count}} Aufträge der Kategorie {{category}}",
itemFailures_one: "{{count}} nicht bestandene Prüfung bei „{{label}}“",
itemFailures_other: "{{count}} nicht bestandene Prüfungen bei „{{label}}“",
categoryIssues_one: "{{count}} Problem der Kategorie {{category}}",
categoryIssues_other: "{{count}} Probleme der Kategorie {{category}}",
jobReopens_one: "{{count}} Wiedereröffnung eines Auftrags",
jobReopens_other: "{{count}} Wiedereröffnungen von Aufträgen",
reopenCount_one: "{{count}} Wiedereröffnung",
reopenCount_other: "{{count}} Wiedereröffnungen",
likelyDriver: "Wahrscheinliche Ursache: {{driver}}",
titleJobCategory: "Wiederkehrendes Muster: {{jobs}} an {{assets}} in {{days}}",
driverJobCategory: "wiederholte Arbeiten der Kategorie {{category}} an ähnlichen Anlagen.",
driverJobCategoryScope: "Derselbe betriebliche Auslöser oder Checklistenumfang wird möglicherweise nicht ausreichend behandelt.",
counterJobCategory: "Bei geplanter Wartung kann sich dieselbe Kategorie zu Recht wiederholen — prüfen Sie die Wartungspläne.",
actionJobCategory: "Prüfen Sie Arbeitsumfang und Reparaturmethode für {{category}} und inspizieren Sie zugehörige Anlagen.",
titleInspectionItem: "Wiederkehrendes Muster: {{failures}} an {{assets}} in {{days}}{{site}}",
siteSame: " am selben Standort",
siteMultiple: " an mehreren Standorten",
driverInspectionItem: "derselbe Prüfpunkt wird wiederholt nicht bestanden ({{label}}).",
driverInspectionItemScope: "Checklistenumfang, Umgebungsbedingungen oder Überprüfung der Reparatur bei diesem Punkt.",
counterInspectionItem: "Saisonale oder einmalige Inspektionsaktionen können vorübergehend zu einer Häufung nicht bestandener Prüfungen führen.",
actionInspectionItem: "Prüfen Sie den Checklistenpunkt „{{label}}“ und inspizieren Sie zugehörige Anlagen am Standort.",
titleAssetRepeat: "Wiederkehrendes Muster: {{asset}} fällt nach der Reparatur erneut aus ({{jobs}} in {{days}})",
driverAssetRepeat: "dieselbe Ausfallkategorie tritt nach der Reparatur erneut auf.",
driverAssetRepeatCause: "Reparaturmethode, Teile oder die eigentliche Fehlerursache wurden möglicherweise nicht geklärt.",
counterAssetRepeat: "Folgearbeiten können eine geplante Überprüfung sein — klären Sie den Zweck des Auftrags.",
actionAssetRepeat: "Prüfen Sie die Reparaturmethode und inspizieren Sie zugehörige Anlagen.",
latestRepair: "Letzte Reparatur",
postRepairInspection: "Inspektion nach der Reparatur mit nicht bestandenen Prüfpunkten",
titleFailureType: "Wiederkehrendes Muster: {{issues}} bei Anlagen vom Typ {{assetType}} ({{assets}}, in {{days}})",
driverFailureType: "Ausfälle der Kategorie {{category}} häufen sich beim Anlagentyp {{assetType}}.",
counterFailureType: "Die Auswahl an Anlagen dieses Typs ist möglicherweise klein — prüfen Sie, ob die Stichprobe repräsentativ ist.",
actionFailureType: "Prüfen Sie die Standards für {{category}} bei Anlagen vom Typ {{assetType}} und die zugehörigen Checklistenpunkte.",
titleTechReopen: "Wiederkehrendes Muster: {{reopens}} im Zusammenhang mit {{name}} in {{days}}",
driverTechReopen_one: "{{name}} steht mit mehrfachen Wiedereröffnungen in {{count}} Kategorie in Verbindung.",
driverTechReopen_other: "{{name}} steht mit mehrfachen Wiedereröffnungen in {{count}} Kategorien in Verbindung.",
driverTechReopenCause: "Abschlusskriterien, Teile oder die Qualität der Übergabe müssen möglicherweise überprüft werden.",
counterTechReopen: "Wiedereröffnungen können auf erneute Kundenmeldungen zurückgehen, die nichts mit dem Können des Technikers zu tun haben.",
actionTechReopen: "Gehen Sie die wiedereröffneten Aufträge mit {{name}} durch und prüfen Sie die Abschlusskriterien.",
titleVendorReopen: "Wiederkehrendes Muster: {{reopens}} beim Auftragnehmer {{name}} in {{days}}",
driverVendor: "Auftragnehmer {{name}} steht mit mehrfachen Wiedereröffnungen in Verbindung.",
counterVendor: "Auslastungsspitzen beim Auftragnehmer können mit Wiedereröffnungen zusammenfallen, ohne dass es Qualitätsprobleme gibt.",
actionVendor: "Prüfen Sie Leistung und Leistungsumfang von Auftragnehmer {{name}}.",
titlePart: "Wiederkehrendes Muster: {{jobs}} mit „{{part}}“ an {{assets}} in {{days}}",
driverPart: "Teil oder Kategorie „{{part}}“ steht mit wiederholten Aufträgen in Verbindung.",
counterPart: "Bei Lagerhaltung oder Wartungssets kann dasselbe Teil zu Recht an mehreren Anlagen vorkommen.",
actionPart: "Prüfen Sie Qualität, Passform und Wartungsumfang für „{{part}}“.",
assetFallback: "Anlage",
jobFallback: "Auftrag",
contractorFallback: "Auftragnehmer",
checklistItemFallback: "Checklistenpunkt",
uncategorised: "Ohne Kategorie",
impactRecurrence: "Wiederholung",
impactRecurrenceValue_one: "{{events}} in {{count}} Tag",
impactRecurrenceValue_other: "{{events}} in {{count}} Tagen",
reviewPattern: "Muster prüfen",
viewJobs: "Aufträge anzeigen",
},
actionPlans: {
reviewData: "Daten prüfen",
reviewDataDetail: "Prüfen Sie den Inspektions- und Auftragsverlauf, bevor Sie Ressourcen einsetzen.",
withinDays_one: "Innerhalb von {{count}} Tag",
withinDays_other: "Innerhalb von {{count}} Tagen",
scheduleWithin_one: "Inspektion innerhalb von {{count}} Tag planen",
scheduleWithin_other: "Inspektion innerhalb von {{count}} Tagen planen",
scheduleWithinDetail: "Prüfen Sie den Zustand und erfassen Sie Nachweise vor Ort.",
openAssetRecord: "Anlagendatensatz öffnen",
openAssetRecordDetail: "Prüfen Sie Verlauf, verknüpfte Aufträge und die Ergebnisse der letzten Inspektion.",
scheduleInspection: "Inspektion planen",
benefitDowntime: "Risiko von Stillstandszeiten senken",
benefitCatchDefects: "Mängel vor dem Ausfall erkennen",
effortFailureUrgent: "Gering — Techniker zuweisen und Zustand der Dichtung prüfen",
effortFailure: "Gering — Zuständigen zuweisen und Checklistenumfang bestätigen",
triageOverdue: "Überfällige Aufträge heute sichten",
triageOverdueDetail: "Neu priorisieren, neu zuweisen oder Fälligkeitsdaten aktualisieren.",
escalateBlockers: "Hindernisse eskalieren",
escalateBlockersDetail: "Zeigen Sie Aufträge auf, die auf Teile, Zugang oder Genehmigungen warten.",
today: "Heute",
benefitSla: "SLA-Einhaltung wiederherstellen und Anwachsen des Rückstands bremsen",
effortOverdue: "Mittel — Zuständige und Fälligkeitsdaten in der gesamten Gruppe prüfen",
renewCertificate: "Zertifikat vor Ablauf erneuern",
renewCertificateDetail: "Buchen Sie die Zertifizierung oder Compliance-Inspektion, bevor die Gültigkeit endet.",
openCompliance: "Compliance-Bereich öffnen",
openComplianceDetail: "Bestätigen Sie Zuständige und Verlängerungstermine je Anlage.",
beforeExpiry: "Vor Ablauf (30 Tage)",
benefitCompliance: "Compliance-Lücken und Risiken bei Audits vermeiden",
effortCompliance: "Gering — Zuständigen und Fälligkeitsdaten für die Verlängerung bestätigen",
reviewReopened: "Wiedereröffnete Aufträge prüfen und Schulung zuweisen",
reviewReopenedDetail: "Gehen Sie wiederholte Ausfälle in den betroffenen Kategorien mit dem Techniker durch.",
viewContacts: "Kontakte anzeigen",
viewContactsDetail: "Prüfen Sie Auslastung und Zuordnung für korrigierende Folgearbeiten.",
thisWeek: "Diese Woche",
benefitRework: "Wiederholte Nacharbeit reduzieren und Erstlösungsquote verbessern",
effortTraining: "Mittel — zu Mustern in den Kategorien schulen und Abschlusskriterien prüfen",
createJob: "Auftrag erstellen",
scheduleOverdue: "Inspektionen für überfällige Anlagen planen",
scheduleOverdueDetail: "Schließen Sie die 90-Tage-Lücke mit Checklisten aus Checklisten.",
openInspections: "Inspektionsbereich öffnen",
openInspectionsDetail: "Planen Sie mehrere auf einmal oder starten Sie im Inspektionsbereich.",
benefitCoverage: "Inspektionsabdeckung und Überblick über Risiken wiederherstellen",
effortInspection: "Gering — Checkliste wählen und Inspektoren zuweisen",
reviewPattern: "Wiederkehrendes Muster prüfen",
inspectRelated: "Zugehörige Anlagen inspizieren",
inspectRelatedDetail: "Gehen Sie die Anlagen der Gruppe ab und prüfen Sie Reparaturmethode, Teile und Checklistenumfang.",
reviewSupporting: "Zugehörige Aufträge und Inspektionen prüfen",
reviewSupportingDetail: "Bestätigen Sie die Nachweise, bevor Sie Standards ändern.",
patternWindow: "Muster · {{value}}",
benefitCycles: "Kreislauf wiederholter Ausfälle durchbrechen und Nacharbeit reduzieren",
effortRootCause: "Mittel — Aufträge, Inspektionen und Reparaturverlauf abgleichen",
viewJobs: "Aufträge anzeigen",
startAssignedJob: "Zugewiesenen Auftrag öffnen und starten",
dueWindow: "Fällig · {{value}}",
whenDue: "Bei Fälligkeit",
benefitOnTrack: "Zugewiesene Arbeit im Plan halten",
effortNextJob: "Gering — Auftrag öffnen und erstes Update schreiben",
openJob: "Auftrag öffnen",
},
};
